import { apiFetch } from "../api.js";
import type {
  CreateEquityGrantInput,
  EquityGrant,
  EquityGrantsListResponse,
  UpdateEquityGrantInput,
} from "./types.js";

export function listEquityGrants(
  includeInactive = false,
): Promise<EquityGrantsListResponse> {
  const qs = includeInactive ? "?include_inactive=true" : "";
  return apiFetch<EquityGrantsListResponse>(`/v1/equity-grants${qs}`);
}

export function getEquityGrant(grantId: string): Promise<EquityGrant> {
  return apiFetch<EquityGrant>(`/v1/equity-grants/${grantId}`);
}

export function createEquityGrant(
  input: CreateEquityGrantInput,
): Promise<EquityGrant> {
  return apiFetch<EquityGrant>("/v1/equity-grants", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function updateEquityGrant(
  grantId: string,
  input: UpdateEquityGrantInput,
): Promise<EquityGrant> {
  return apiFetch<EquityGrant>(`/v1/equity-grants/${grantId}`, {
    method: "PATCH",
    body: JSON.stringify(input),
  });
}

export function deleteEquityGrant(grantId: string): Promise<void> {
  return apiFetch<void>(`/v1/equity-grants/${grantId}`, { method: "DELETE" });
}
